import styled from 'styled-components'

export default styled.div`
  position: relative;
  height: 74px;
  max-width: 315px;
`
